import GlobalSiteTag from "@/managers/session/logging/globalSiteTag"
import AWSLog, {Level} from "@/managers/session/logging/awsLog"
import Configuration from "@/managers/system/configuration"

class Log {
	private readonly shouldLog = !Configuration.general.noErrorLogEnvironments.some(environment => environment === Configuration.connections.errorLogEnvironment)

	public setCanTrack(canTrack: boolean): void {
		GlobalSiteTag.setCanTrack(canTrack)
	}

	public setUserId(userId: string | null): void {
		AWSLog.setUserId(userId)
		GlobalSiteTag.setUserId(userId)
	}

	public event(category: string, action: string, label?: string): void {
		if (!this.shouldLog)
			return

		GlobalSiteTag.logGTMEvent(action, {category, label: label ?? ""})

		if (Configuration.general.logNoneCriticalToAWS)
			AWSLog.event(category, action, label)
	}

	public error(message: string, error?: Error, fatal: boolean = true): void {
		if (!this.shouldLog)
			return

		GlobalSiteTag.logEvent("exception", {name: error?.name ?? "", description: error?.message ?? "", fatal: fatal ? "true" : "false"})
		AWSLog.error(message, error, fatal)
	}

	public informationNotification(message: string): void {
		if (!this.shouldLog)
			return

		if (Configuration.general.logNoneCriticalToAWS)
			AWSLog.log(message, Level.information)
	}

	public login(method: string): void {
		if (!this.shouldLog)
			return

		GlobalSiteTag.logGTMEvent("login", {method})
		if (Configuration.general.logNoneCriticalToAWS)
			AWSLog.event("Authentication", "login", method)
	}

	public signUp(method: string): void {
		if (!this.shouldLog)
			return

		GlobalSiteTag.logGTMEvent("sign_up", {method})
		if (Configuration.general.logNoneCriticalToAWS)
			AWSLog.event("Authentication", "signUp", method)
	}
}

export default new Log()
